import makeLookupModal from "../../UI/LookupModal/LookupModal";
import ProspectSourceCategoryLookup from "./ProspectSourceCategoryLookup";
const ProspectSourceCategoryLookupModal = makeLookupModal(ProspectSourceCategoryLookup, {
    pluralEntityName: "Prospect Source Categories",
});
export default ProspectSourceCategoryLookupModal;
